/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Onboarding status
 * @export
 * @interface GetServiceproviderOnboardingStatus200Response
 */
export interface GetServiceproviderOnboardingStatus200Response {
    /**
     * A colleague was invited to the serviceprovider team.
     */
    teamInvited?: boolean;
    /**
     * A free NFR monitoring client exists.
     */
    nfrClientCreated?: boolean;
    /**
     * Admin consent was granted for Entra ID on a monitoring client.
     */
    entraConnected?: boolean;
    /**
     * A collector reported back for a monitoring client.
     */
    collectorConnected?: boolean;
    /**
     * Monitoring client the Entra and collector steps refer to.
     */
    firstClientUUID?: string | null;
}

/**
 * Check if a given object implements the GetServiceproviderOnboardingStatus200Response interface.
 */
export function instanceOfGetServiceproviderOnboardingStatus200Response(value: object): value is GetServiceproviderOnboardingStatus200Response {
    return true;
}

export function GetServiceproviderOnboardingStatus200ResponseFromJSON(json: any): GetServiceproviderOnboardingStatus200Response {
    return GetServiceproviderOnboardingStatus200ResponseFromJSONTyped(json, false);
}

export function GetServiceproviderOnboardingStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceproviderOnboardingStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'teamInvited': json['teamInvited'] == null ? undefined : json['teamInvited'],
        'nfrClientCreated': json['nfrClientCreated'] == null ? undefined : json['nfrClientCreated'],
        'entraConnected': json['entraConnected'] == null ? undefined : json['entraConnected'],
        'collectorConnected': json['collectorConnected'] == null ? undefined : json['collectorConnected'],
        'firstClientUUID': json['firstClientUUID'] === undefined ? undefined : json['firstClientUUID'] === null ? null : json['firstClientUUID'],
    };
}

export function GetServiceproviderOnboardingStatus200ResponseToJSON(json: any): GetServiceproviderOnboardingStatus200Response {
    return GetServiceproviderOnboardingStatus200ResponseToJSONTyped(json, false);
}

export function GetServiceproviderOnboardingStatus200ResponseToJSONTyped(value?: GetServiceproviderOnboardingStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamInvited': value['teamInvited'],
        'nfrClientCreated': value['nfrClientCreated'],
        'entraConnected': value['entraConnected'],
        'collectorConnected': value['collectorConnected'],
        'firstClientUUID': value['firstClientUUID'],
    };
}

